export function ChatbotPreview() {
  return <div>Chatbot Preview</div>;
}
